import { Badge, Checkbox, Modal } from 'antd';
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import CrossCircle from '../../common/assets/svgIcons/CrossCircle';
import classNames from 'classnames';
import { maxMobile, maxWidth, nutenixGradientColor, primaryColor, primaryFont, retina, secondaryFont, wMedium } from '../../../Utils/utilsStyle';
import PeopleWidgetWithOutHolo from '../../common/components/PeopleWidgetWithOutHolo';
import { Executive } from '../../../Types/PersonTypes';
import { backgroundColorParsing, isFreeUser, parseColorGradientMixture } from '../../../Utils/UtilityFunctions';
import { translateSkipAreas } from '../../../Utils/Constants';
import SharedBadge from '../../common/components/SharedBadge';
import ShareGroupPeopleModal from '../../common/modal/ShareGroupPeopleModal';
import BinIconCommon from '../../common/assets/svgIcons/BinIconCommon';
import { GroupPersonality } from '../../../Types/GroupsTypes';
import { selectDisclessPersonality } from '../../../Selector/GlobalSearchContentSelector';
import { actions as clusterActions } from '../../../Slice/ClustersSlice';
import { selectDeletingLoader } from '../../../Selector/GroupsSelector';
import { Company } from '../../../Types/CompaniesTypes';

const Wrapper = styled.div<{ color: string, }>`
  background:conic-gradient(from -70deg, ${(props) => props.color});
  padding: 4px;
  border-radius: 20px;
  margin-bottom: 6px;
  position: relative;
  cursor: pointer;
  min-height: 100px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    border-radius: 11px;
    padding: 3px;
  }

  &.smallView {
    min-height: 92px;
    .card-inner-wrapper {
      min-height: 90px;
    }
  }

  .data-share-wrapper-div {
    position: absolute;
    right: 0.5px;
    bottom: 0.5px;
    display: flex;
    align-items: center;
    .share-delt-div {
      height: 34px;
      width: 67px;
      background: #f1f1f1;
      opacity: 1;
      border-radius: 12px 0 8px;
      padding: 8px 10px;
      .Pined {
        path {
          fill: ${primaryColor} !important;
          stroke: ${primaryColor} !important;
        }
      }
      svg {
        g {
          opacity: 1 !important;
        }
        path {
          fill: #2F363A !important;
        }
      }
    }
    .pinnedElement {
     position: absolute;
     right: 5px;
     bottom: 40px;
     width: 41px;
     height: 14px; 
     border-radius: 12px;
     background-color: ${primaryColor};
     color: #FFF;
     font-size: 10px;
     font-weight: ${wMedium};
     letter-spacing: -0.45px;
     font-family: ${primaryFont};
     display: flex;
     justify-content: center;
     align-items: center;
    }
    .shared {
      margin-right: 15px;
    }
  }
  
  .card-inner-wrapper {
    position: relative;
    background-color:#FFFFFF;
    border-radius:16px;
    padding: 10px 0px;
    width:100%;
    min-height: 98px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      border-radius: 9px;
    }
    
    .logo-side {
      width: 20%;
      margin:0px 0px 0px 25px;
    }

    .other-side {
      width: calc(60% - 20px);
      padding-right: 20px;
      padding-left: 25px;
      position: relative;
      margin-bottom: 2px;
      @media all and (max-width: 420px) {
        padding-left: 10px;
      }
      svg {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          width:12px;
        }
      }
    }
    .add-remove-div {
      margin-right: 16px;
    }
    .logo-image{
      margin:16px 0 0 -8px;
      img{
        max-height: 25px;
        height:25px;
        width:auto;
        max-width:30px;
        margin:0 2px;
        @media all and (max-width: ${maxMobile}) {
          &:nth-child(3) {
            display: none;
          }
        }
      }
    }
    .buyer-name{
      color: #000;
      font-family: ${secondaryFont};
      font-weight:${wMedium};
      font-size: 18px;
      line-height: 25px;
      text-align: left;
      padding:0px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 16px;
        line-height: 20px;
      }
    }
    .user-images{
      margin-top:10px;
      margin-bottom:26px;
      position: relative;
      z-index:0;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        margin-top:8px;
        margin-bottom:15px;
      }
      > div{
        padding:2px !important;
        &:nth-child(1){
          z-index:4;
          margin-left: -8px;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            margin-left: -15px;
          }
        }
        &:nth-child(2){
          z-index:3;
          margin-left: -8px;
        }
        &:nth-child(3){
          z-index:2;
          margin-left: -8px;
        }
        &:nth-child(4){
          z-index:1;
          margin-left: -8px;
        }
      }
    }
    .checkbox-div {
      justify-content: end;
      padding-right: 0px;
      margin-left: 20px;
      .ant-checkbox-wrapper {
        margin-bottom: 0px;
      }
    }
    .share-delt-div {
      display: flex;
      align-content: center;
      justify-content: space-between;
      .Pined {
        path {
          fill: ${primaryColor} !important;
          stroke: ${primaryColor} !important;
        }
      }
      .share-button-group {
        background: none;
        padding: 0px;
        .icon-mode{
          .icon-mode-text {
            display: none;
          }
          .seperator {
            display: none;
          }
          .share-icon{
            svg {
              height: 20px;
              width: 15px;
              min-width: 15px;
              g {
                fill: #A0A4A7;
              }
              &:hover {
                path {
                  fill: ${primaryColor};
                }
              }
            }
          }
        }
      }
      .delt-div {
        padding: 0px;
        svg {
          width: 15px;
          min-width: 15px;
        }
      }
    }
  }
  .zeroAppend{
    margin-top: -14px;
  }  
`;
const PopupModal = styled(Modal)`
&.delete-grp-popup {
  .ant-modal-close {
    .ant-modal-close-x {
      display: block;
    }
    :hover {
      background-color: transparent;
    }
  }
  .ant-modal-body {
    padding: 24px;
  }
  .ant-modal-footer {
    .ant-btn {
      padding: 4px 15px;
    }
  }
}
  .ant-modal-content{
    .ant-modal-footer{
      display: flex;
      justify-content: center;
      flex-direction: row-reverse;
    }
  }
`;
const CustomBadge = styled(Badge)`
  .ant-badge-multiple-words {
    padding: 0px 0px;
  }
  .ant-badge-count span {
    margin-top: 0px;
  }
  .ant-badge-count{
    z-index: 4;
    font-size: 11px;
    font-family: ${primaryFont};
    background:#424B50;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer; 
    height: 25px;
    width: 25px;
    position: absolute;
    top: 15px;
    right: -2px;
    border-radius: 16px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 8px;
      height: 18px;
      width: 18px;
      min-height: 18px;
      min-width: 18px;
      top:10px;
      border-radius: 10px;
    } 
  }
`;
type Props = {
  clusterPersona?: GroupPersonality[]
  clusterName?: string
  shareClusterCheckBox?: boolean
  isChecked?: boolean
  onSelectCluster?: (clusterId: number) => void;
  isShared: boolean
  sharedBy: Executive
  clusterId: number
  companies?: Company[]
  createdBy: Executive
};

const defaultProps = {
  groupPersona: [{
    color: '#9797',
    end: '100%',
    percentage: 100,
    start: '0%',
  }],
  clusterName: 'Not valid group',
  shareClusterCheckBox: false,
  isChecked: false,
  isShared: false,
  sharedBy: null,
  clusterId: 0,
  companies: [],
  createdBy: null,
}
const ClustersDisplayWidget = function ClustersDisplayWidget(props: Props) {
  const { clusterName, shareClusterCheckBox, isChecked, isShared, sharedBy, clusterId, clusterPersona, companies, createdBy, onSelectCluster, } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const deleteLoader = useSelector(selectDeletingLoader);

  const handleOk = () => {
    if (clusterId && !deleteLoader) {
      dispatch(clusterActions.manageAccountCluster({
        type: "delete",
        clusterId: clusterId,
      }))
    }
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const deleteCluster = (e: { stopPropagation: () => void; }) => {
    e.stopPropagation();
    setIsModalVisible(true);
  };

  const shareGroupHandler = (check: boolean) => {
    if (check) {
      dispatch(clusterActions.setSelectedClusters([{
        clusterName: clusterName || '',
        clusterId: clusterId || 0
      }]));
    }
  };
  return (
    <>
      <PopupModal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} centered cancelText="No" okText="Yes" closeIcon={<CrossCircle />} width="530px" className="delete-grp-popup">
        <p className="text_logout_popup main-message">Are you sure you want to delete the cluster?</p>
      </PopupModal>
      <Wrapper
        color={disclessPersonality
          ? nutenixGradientColor
          : parseColorGradientMixture(clusterPersona || [])}
        className={classNames(
          'group-display-widget',
          // { active, smallView: personsCount === 0 },
        )}
      // {...(!(shareClusterCheckBox || isChecked) ? {} : { onClick: onClickHandler })}
      >
        <div
          className="card-inner-wrapper"
          role="button"
          tabIndex={-1}
        // onClick={navigation}
        // onKeyPress={navigation}
        >
          <div className="d-flex align-items-center card-inner-div">
            <div className="logo-side">
              <div className="d-flex logo-image">
                {companies?.slice(0, 3).map((company) => <img src={company.companyLogo} alt="" />)}
              </div>
              <div className="d-flex user-images">
                {createdBy && (
                  <PeopleWidgetWithOutHolo
                    logo={createdBy?.personImage}
                    persona={createdBy?.archeType.color}
                    diameter="30px"
                    diameterSm="30px"
                    diameterXsm="30px"
                    margin="0"
                    wrapperColor={backgroundColorParsing(createdBy.personalityTypes)}
                  />
                )}
              </div>
            </div>
            <div className="other-side">
              <div className={`buyer-name text-truncate-two-line ${translateSkipAreas}`}>
                {clusterName}
              </div>
            </div>
            {shareClusterCheckBox ? (
              <div className="checkbox-div">
                <Checkbox
                  checked={isChecked}
                  onChange={() => onSelectCluster?.(clusterId)}
                />
              </div>
            ) : null}

            {!shareClusterCheckBox
              ? (
                <div className="data-share-wrapper-div">
                  {isShared ? <SharedBadge label={`Shared by ${sharedBy?.personName}`} /> : null}
                  {/* {pin === 1 ? (
                    <div className="pinnedElement">
                      Pinned
                    </div>
                  ) : null} */}
                  <div
                    className="share-delt-div"
                    onClick={(e) => e.stopPropagation()}
                    onKeyPress={(e) => e.stopPropagation()}
                    role="button"
                    tabIndex={-1}
                  >
                    {/* <PinItemSvg
                      onClickElement={pinGroupHandler}
                      className={classNames({ Pined: pin === 1 })}
                    /> */}
                    {!isFreeUser()
                      && (
                        <ShareGroupPeopleModal
                          key={clusterId}
                          onClickHandler={() => {
                            shareGroupHandler(true);
                            // certificationShareAction();
                          }}
                          onCancelHandler={() => shareGroupHandler(false)}
                          iconMode
                          inClusterMode={true}
                        />
                      )}
                    <div
                      onClick={deleteCluster}
                      onKeyPress={deleteCluster}
                      role="button"
                      tabIndex={-1}
                      className="delt-div"
                    >
                      <BinIconCommon />
                    </div>
                  </div>
                </div>
              ) : null}
          </div>
        </div>
      </Wrapper>
    </>
  );
};

ClustersDisplayWidget.defaultProps = defaultProps;
export default ClustersDisplayWidget;
